<template>
    <div class="xl">
        <div class="flex items-center justify-between pt-2 pb-1">
            <div class="text-2xl font-bold">Products</div>
        </div>
        <div class="text-xs pb-2">Update defect type and notes only. Product list cannot be changed.</div>

        <div class="rounded-t">
            <table class="table w-full">
                <thead>
                    <tr class="h-10 align-bottom bg-gray-light border">
                        <th class="w-48"></th>
                        <th class="text-left">Ordered</th>
                        <th class="text-left">Product</th>
                        <th class="text-left">Quantity</th>
                        <th class="text-left w-64">Defect</th>
                        <th class="text-left w-80">Notes</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in ordered_products" :key="item.refund_order_item?.id || index">
                        <td class="text-left">
                            <img v-if="item.image != null" :src="'/storage/' + item.image" class="mx-auto max-h-20" alt="Product Image" loading="lazy" />
                            <img v-else src="/images/product-placeholder.png" class="mx-auto max-h-20" alt="No Image" loading="lazy" />
                        </td>
                        <td class="text-left">
                            {{ item.quantity }}
                        </td>
                        <td class="text-left">
                            {{ item.product?.title || item.title }}
                            <span v-if="(item.product?.description || item.description)"> - {{ item.product?.description || item.description }}</span>
                            <span v-if="(item.product?.size || item.size)"> - {{ item.product?.size || item.size }}</span>
                            <span v-if="item.product?.special_order" class="ml-1 text-xs italic text-red">(Special Order Item)</span>
                        </td>
                        <td class="text-left" aria-readonly="true">
                            <span class="inline-block">{{ item.refund_order_item?.quantity }}</span>
                        </td>
                        <td class="md:table-cell text-left">
                            <multiselect
                                class="multi-lg h-8 text-base"
                                v-model="form.itemReason[item.refund_order_item.id]"
                                :options="returnReasons"
                                valueProp="value"
                                trackBy="label"
                                label="label"
                                placeholder="Select Defect"
                            />
                            <jet-input-error :message="$page.props.errors['itemReason.' + item.refund_order_item.id]" class="mt-1" />
                        </td>
                        <td class="md:table-cell text-left">
                            <div v-if="item.parent_id">
                                Part of {{ item.parent_item?.title }}
                            </div>
                            <textarea
                                v-model="form.returnNote[item.refund_order_item.id]"
                                class="w-full"
                                rows="2"
                                placeholder="Type a description..."
                            />
                            <jet-input-error :message="$page.props.errors['returnNote.' + item.refund_order_item.id]" class="mt-1" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import JetInputError from '@/Jetstream/InputError';

import '@vueform/multiselect/themes/default.css';

export default {
    components: {
        Multiselect,
        JetInputError,
    },

    props: [
        'form',
        'ordered_products',
        'returnReasons',
    ],
};
</script>
